// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DirectMessageCode } from "../../Utils/DirectMessages/DirectMessagesImport.ts"


export let SourceCollection = function (collection)
{
    this.routeID = null
    this.cache = {}
    if (collection)
        this.Update(collection)
}

SourceCollection.prototype.Update = function (collection)
{
    let cache = collection.cache
    for (let key in cache)
    {
        let item = cache[key]
        this.AddSource(key, item.Name, item.ExternalId)
    }
}

SourceCollection.prototype.AddSource = function (id, name, externalId)
{
    let src = new Source(id, name, externalId)
    this.cache[src.Id] = src
}

SourceCollection.prototype.GetSourceName = function (id)
{
    let source = this.getSource(id)
    return source ? source.Name : id.toString()
}

SourceCollection.prototype.getSource = function (id)
{
    return this.cache[id]
}

SourceCollection.prototype.UpdateByMessage = function (msg)
{
    if (!msg || msg.Code != DirectMessageCode.CODE_SOURCE_LIST)
        return

    this.routeID = msg.RouteId

    if (msg.SourceIDs)
        for (let i = 0; i < msg.SourceIDs.length; i++)
            this.AddSource(msg.SourceIDs[i], msg.SourceNames[i], msg.SourceExternalIds[i])
}


export let Source = function (id, name, externalId)
{
    this.Id = id
    this.Name = name
    this.ExternalId = externalId
}